import {MediaItemType} from "store/media/Media.types";

type HistoryLocationState = {
  fromArrangement?: number;
  fromSpot?: {
    id: number;
    mediaItems: any;
  };
  fromMediaType?: MediaItemType;
  fromArrangementFormFormValues?: any;
  newArrangement?: any;
  unprocessableMediaItems?: any;
  fromTrigger?: number;
  fromTriggerFormFormValues?: any;
  arrangement?: any;
  newTrigger?: any;
  infoMessage?: any;
  fromEvent?: number;
  fromEventFormFormValues?: any;
  selectedArrangements?: Array<{ id?: number }>;
  existingShowIds?: number[];
  newEvent?: any;
  groupAdded?: any;
  groupDeleted?: any;
  passwordReset?: any;
};

export const clearedEventLocationState = {
  fromEvent: undefined,
  fromEventFormFormValues: undefined,
  selectedArrangements: undefined,
  existingShowIds: undefined,
  newEvent: undefined,
};

export default HistoryLocationState;
